export const API_PATH2 = "https://intranet.mccann.com.mx/wp-json/wp/v2/";
export const API_PATH =  "https://mccannet.mccann.com.mx/wp-json/wp/v2/";
